import React, { useEffect, useState } from 'react';
import './RealStoriesSection.css';

const feedbacks = [
	{
		logo: '' + process.env.PUBLIC_URL + '/assets/aziro/aziro.jpg',
		website: 'https://aziro.com',
		content: 'The “Outstanding Workplaces” is a great new initiative by Vanakkam HRD to recognize organizations and teams that put in differentiated effort to demonstrate excellence in people practices. The event that was organized recently at the Hilton in Chennai reflected the passion and dedication of the team to put together an event that took quality time and effort in recognizing companies and teams that went beyond the call of duty in creating “Outstanding Workplaces".',
		name: 'Bharathan Prahalad',
		designation: 'Vice President - HR',
		company: 'Aziro'
	},
	{
		logo: process.env.PUBLIC_URL + '/assets/contustech/contus.png',
		website: 'https://www.contus.com',
		content: 'Our team needed to see what true excellence looked like across different industries. The challenge was finding a single, well-curated forum. Outstanding Workplaces delivered beyond expectation. The well-organized platform seamlessly featured top organizations from countless business domains, making the comparison meaningful, not chaotic. This isn\'t a flash-in-the-pan event; it’s a standard-setter. We left knowing this platform is here to stay and will continue to be our annual compass for rewarding and growing our commitment to better People Management.',
		name: 'Vijay Kumar',
		designation: 'Associate Vice President HR',
		company: 'Contus Tech'
	},
	{
		logo: process.env.PUBLIC_URL + '/assets/novac/novac.png',
		website: 'https://www.novactech.com',
		content: 'We sincerely appreciate Outstanding Workplaces for organizing a highly professional and impactful event. The entire process—from nomination to evaluation and final recognition—was exceptionally well structured, transparent, and guided by clearly defined criteria. It not only ensured fairness and credibility but also reinforced trust in the recognition being conferred. Kudos to the Outstanding Workplaces team for their meticulous planning, seamless execution, and commitment to celebrating organizations that genuinely put people first. We look forward to continued association and wish you greater success in the years ahead.',
		name: 'Prakash Ranganathan',
		designation: 'Vice President & CHRO',
		company: 'Novac Technology Solutions'
	},
	{
		logo: process.env.PUBLIC_URL + '/assets/foodhub/foodhublogo.png',
		website: 'https://www.foodhubcareers.com',
		content: 'The Outstanding Workplaces certification process was both rigorous and authentic. What stood out for us at Foodhub was the depth of assessment—grounded in real employee voices, data-driven insights, and an objective evaluation of our culture, practices, and leadership behaviours. The process encouraged honest reflection, validated what we are doing right, and clearly highlighted areas where we can do better. That transparency and credibility make this certification truly meaningful. At Foodhub, we are deeply committed to building and sustaining a positive, inclusive, and high-trust work culture—one where people feel valued, heard, and empowered to grow. This recognition reinforces our belief that culture is not a one-time achievement, but a continuous journey. We see this certification not as a milestone, but as a responsibility to consistently raise the bar for our people experience.',
		name: 'Suresh Aade',
		designation: 'Head – HR',
		company: 'Foodhub Software Solutions'
	},
    // Add more feedback objects as needed
];

const AUTO_SCROLL_INTERVAL = 3500; // ms


const RealStoriesSection = () => {
	const [current, setCurrent] = useState(0);
	const [isPaused, setIsPaused] = useState(false);
	useEffect(() => {
		if (isPaused) return;
		const timer = setInterval(() => {
			setCurrent((prev) => (prev + 1) % feedbacks.length);
		}, AUTO_SCROLL_INTERVAL);
		return () => clearInterval(timer);
	}, [isPaused]);

	const goTo = (idx) => setCurrent(idx);
	const prev = () => setCurrent((current - 1 + feedbacks.length) % feedbacks.length);
	const next = () => setCurrent((current + 1) % feedbacks.length);

	const fb = feedbacks[current];
	// Pause auto-scroll on hover over the content area
	const handleMouseEnter = () => setIsPaused(true);
	const handleMouseLeave = () => setIsPaused(false);

	return (
		<section className="real-stories-section">
			<div className="real-stories-heading">
				Real Stories, Real Results, Happy Clients
			</div>
			<div className="real-stories-slider">
				<button className="arrow left edge-arrow" onClick={prev} aria-label="Previous">
					<span className="arrow-icon">
						<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M22 28L14 18L22 8" stroke="#555A60" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</span>
				</button>
				<div className="real-story-slide" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
					<a href={fb.website} target="_blank" rel="noopener noreferrer">
						<img src={fb.logo} alt="Company Logo" className="company-logo" />
					</a>
					<div className="story-content stylish-font">{fb.content}</div>
					<div className="story-author">
						<span className="author-name">{fb.name}</span>
						<span className="author-designation">{fb.designation}</span>
						<span className="author-company">{fb.company}</span>
					</div>
				</div>
				<button className="arrow right edge-arrow" onClick={next} aria-label="Next">
					<span className="arrow-icon">
						<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M14 8L22 18L14 28" stroke="#555A60" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</span>
				</button>
			</div>
			<div className="slider-dots">
				{feedbacks.map((_, idx) => (
					<span
						key={idx}
						className={`dot${idx === current ? ' active' : ''}`}
						onClick={() => goTo(idx)}
						aria-label={`Go to slide ${idx + 1}`}
					/>
				))}
			</div>
		</section>
	);
};

export default RealStoriesSection;
